var FcEquipmentTypeInputModule = /** @class */ (function () {
    function FcEquipmentTypeInputModule() {
    }
    return FcEquipmentTypeInputModule;
}());
export { FcEquipmentTypeInputModule };
